import React, { memo } from 'react';
import './index.scss';
import icons from '@icons';
import { Picture } from '@ui';
import { Link } from '@compat/router';
import HeaderCart from '../MainHeader/HeaderCart';
import useWindowSize from '@customHooks/useWindowSize';
import Logo from '@components/Logo';

const {
  chevronRight: { darkGrey: crDGoutlined },
  bonus: { gold: bonus },
  shield: { gold: shield }
} = icons.Outline;

const RegisterOrderHeader = () => {
  const { isMobile } = useWindowSize();
  const iconSize = isMobile ? '28' : '40';

  return (
    <header className='create-order-header'>
      <Logo className='logoLink' />
      <div className='right-side'>
        <Link className='imgComponent' to='/loyalty-program' target='_blank'>
          <Picture icon={bonus} width={iconSize} height={iconSize} />
          <div className='text'>
            <span className='title'>
              Кэшбэк до 3%
              <Picture icon={crDGoutlined} width='16' height='16' />
            </span>
            {/* <span className='details'>Оплачивайте бонусами до 100% заказа</span> */}
          </div>
        </Link>
        <Link className='imgComponent' to='/warranty' target='_blank'>
          <Picture icon={shield} width={iconSize} height={iconSize} />
          <div className='text'>
            <span className='title'>
              Легкий возврат
              <Picture icon={crDGoutlined} width='16' height='16' />
            </span>
            {/* <span className='details'>Быстро вернем деньги или бонусы</span> */}
          </div>
        </Link>
        <HeaderCart />
      </div>
    </header>
  );
};

export default memo(RegisterOrderHeader);
